export const ALL_BENEFIT_TABEL_DATA = {
    energy: {
        headerName: '活力值',
        list: [100, 200, 300, 400, 500, 600, 800, 1100]
    },
    interestFreeEquityDay: {
        headerName: '免息权益日',
        list: [
            { title: '10元免息券', desc: '(每月可领)' },
            { title: '10元免息券', desc: '(每月可领)' },
            { title: '30元免息券', desc: '(每月可领)' },
            { title: '30元免息券', desc: '(每月可领)' },
            { title: '30元免息券', desc: '(每月可领)' },
            { title: '50元免息券', desc: '(每月可领)' },
            { title: '50元免息券', desc: '(每月可领)' },
            { title: '150元免息券', desc: '(每月可领)' }
        ]
    },
    discountCoupon: {
        headerName: '息费折扣券',
        list: [
            null,
            { title: '息费9.8折', desc: '（每半年一次）' },
            { title: '息费9.8折', desc: '（每半年一次）' },
            { title: '息费9.5折', desc: '（每半年一次）' },
            { title: '息费9.5折', desc: '（每半年一次）' },
            { title: '息费9折', desc: '（每半年一次）' },
            { title: '息费9折', desc: '（每半年一次）' },
            { title: '息费8.5折', desc: '（每半年一次）' }
        ]
    },
    interestFreeCoupon: {
        headerName: '免息券',
        list: [
            null,
            { title: '5元免息券', desc: '（仅1次）' },
            { title: '8元免息券', desc: '(每月可领)' },
            { title: '10元免息券', desc: '(每月可领)' },
            { title: '12元免息券', desc: '(每月可领)' },
            { title: '15元免息券', desc: '(每月可领)' },
            { title: '20元免息券', desc: '(每月可领)' },
            { title: '30元免息券', desc: '(每月可领)' }
        ]
    },
    repaymentCoupon: {
        headerName: '还款券',
        list: [
            null,
            { title: '1元还款券', desc: '（仅1次）' },
            { title: '1元还款券', desc: '(每月可领)' },
            { title: '2元还款券', desc: '(每月可领)' },
            { title: '2元还款券', desc: '(每月可领)' },
            { title: '3元还款券', desc: '(每月可领)' },
            { title: '5元还款券', desc: '(每月可领)' },
            { title: '6元还款券', desc: '(每月可领)' }
        ]
    },
    phoneBillCoupon: {
        headerName: '话费券',
        list: [
            null,
            { title: '2元话费券', desc: '(仅1次)' },
            { title: '2元话费券', desc: '(每月可领)' },
            { title: '3元话费券', desc: '(每月可领)' },
            { title: '5元话费券', desc: '(每月可领)' },
            { title: '5元话费券', desc: '(每月可领)' },
            { title: '8元话费券', desc: '(每月可领)' },
            { title: '10元话费券', desc: '(每月可领)' }
        ]
    },
    limitGrowthPlan: {
        headerName: '额度成长计划',
        list: [
            null,
            null,
            { title: '提额特权', desc: '' },
            { title: '提额特权', desc: '' },
            { title: '提额特权', desc: '' },
            { title: '提额特权', desc: '' },
            { title: '提额特权', desc: '' },
            { title: '提额特权', desc: '' }
        ]
    },
    // elemCoupon: {
    //     headerName: '饿了么红包',
    //     list: [
    //         null,
    //         null,
    //         { title: '5折', desc: '' },
    //         { title: '5折', desc: '' },
    //         { title: '5折', desc: '' },
    //         { title: '5折', desc: '' },
    //         { title: '5折', desc: '' },
    //         { title: '5折', desc: '' }
    //     ]
    // },
    creditCardRepayment: {
        headerName: '还信用卡',
        list: [
            null,
            null,
            { title: '免手续费', desc: '' },
            { title: '免手续费', desc: '' },
            { title: '免手续费', desc: '' },
            { title: '免手续费', desc: '' },
            { title: '免手续费', desc: '' },
            { title: '免手续费', desc: '' }
        ]
    },
    physicalGift: {
        headerName: '实物礼包',
        list: [
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            { title: '100元', desc: '' }
        ]
    },
    lifeEquity: {
        headerName: '生活权益',
        list: [
            { title: '周周上新', desc: '' },
            { title: '周周上新', desc: '' },
            { title: '周周上新', desc: '' },
            { title: '周周上新', desc: '' },
            { title: '周周上新', desc: '' },
            { title: '周周上新', desc: '' },
            { title: '周周上新', desc: '' },
            { title: '周周上新', desc: '' }
        ]
    },
    vipCustomerService: {
        headerName: 'VIP客服',
        list: [
            null,
            null,
            null,
            null,
            null,
            { title: '专线接听', desc: '' },
            { title: '专线接听', desc: '' },
            { title: '专线接听', desc: '' }
        ]
    }
};

export const TASK_STATUS_MAP = {
    0: '未完成',
    1: '认证中',
    3: '已领取'
};
